export default __webpack_public_path__ + "static/media/mysteryBetLogo.986bf437.png";